import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { LOGISTIC_TAG, logisticTasksApi } from "../../../../entities/logistic/logisticTasks/redux/logisticTasks.api";

const useTagTigerGetLogisticById = () => {
  const { logisticTaskId } = useParams();

  const dispatch = useDispatch();

  return () => dispatch(
    logisticTasksApi.util.invalidateTags([{ ...LOGISTIC_TAG, id: logisticTaskId }])
  );
};

export default useTagTigerGetLogisticById;
